export const personKey = ["person"] as const;
export const organizationKey = ["organization"] as const;
export const factKey = ["personFact"] as const;
export const personDetailsKey = [...personKey, "details"] as const;
export const relationKey = [...personKey, "relations"] as const;
